
import { cn } from "@/lib/utils"

/**
 * Stili per la lista di tab
 */
export const getTabsListStyles = (className?: string) => {
  return cn(
    "inline-flex h-10 items-center justify-start rounded-md bg-muted p-1 text-muted-foreground w-full overflow-x-auto hide-scrollbar sm:justify-center",
    className
  )
}

/**
 * Stili per il trigger del tab
 */
export const getTabsTriggerStyles = (className?: string) => {
  return cn(
    "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:border-b-2 data-[state=active]:border-primary flex-shrink-0 sm:flex-1",
    className
  )
}

/**
 * Stili per il contenuto del tab
 */
export const getTabsContentStyles = (className?: string) => {
  return cn(
    "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    className
  )
}

